<template lang="pug">
.family-message-history-detail-family-list-accordioin
  // unread accordion
  .unread-accordion(v-if="type == 0")
    b-card-header#read-unread.p-2(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-read-unread)
      span.toggle-text 未読家族（{{ families.length }}件）
    b-collapse#accordion-read-unread(accordion="read-unread-accordion" role="tabpanel")
      b-card-body.p-2
        AccordionLoading(:isBusy="isBusy")
        MessageHistoryFamilyList(v-show="!isBusy" v-model="families")
  // readed accordion
  .readed-accordion(v-if="type == 1")
    b-card-header#read-unread.p-2(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-read-readed)
      span.toggle-text 既読家族（{{ families.length }}件）
    b-collapse#accordion-read-readed(accordion="read-readed-accordion" role="tabpanel")
      b-card-body.p-2
        AccordionLoading(:isBusy="isBusy")
        MessageHistoryFamilyList(v-show="!isBusy" v-model="families")
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { userStore } from "@/store/store";
import { MobileMessageHistoryState } from "@/store/MobileMessageHistory";

import SendMessageReadFamiliesService, { SendMessageReadFamilyModel } from "@/commons/services/SendMessageReadFamilies";

import MessageHistoryFamilyList from "@/mobile/components/lists/MessageHistoryFamilyList.vue";
import AccordionLoading from "@/mobile/basics/AccordionLoading.vue";

/**
 * ### 送信履歴詳細(家族)送信メッセージ未読/既読の家族リスト
 *
 * - 表示対象に応じて未読家族リストか既読家族リストを表示するか判断する
 */
@Component({
  components: {
    AccordionLoading,
    MessageHistoryFamilyList
  }
})
export default class FamilyListAccordioin extends Vue {
  /** 送信メッセージにひもづく家族サービス */
  @Inject("SendMessageReadFamiliesService") sendMessageReadFamiliesService!: SendMessageReadFamiliesService;

  /** ### 新規送信入力画面での入力情報 */
  @Getter("mobileMessageHistoryState") state!: MobileMessageHistoryState;

  /** 表示対象(既読家族、未読家族) */
  @Prop({ required: true })
  type!: FamilyListAccordioinType;

  /** ローディングの表示可否 */
  isBusy: boolean = false;
  /** 表示対象家族 */
  families: Array<SendMessageReadFamilyModel> = [];

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面表示情報を作成する
   *
   * - 画面表示用に返信未読数をカウントする
   * - 未読・既読の家族を表示するコンポーネント用の情報を作成する
   */
  public async createView(): Promise<void> {
    this.isBusy = true;

    // 未読・既読の家族を表示するコンポーネント用の情報を作成する
    const readFamilies: Array<SendMessageReadFamilyModel> = await this.getSendMessageReadFamilies();
    let unreadFamilies: Array<SendMessageReadFamilyModel> = [];
    let readedFamilies: Array<SendMessageReadFamilyModel> = [];
    for (let family of readFamilies) {
      if (family.readDatetime != undefined || family.readDatetime != null) {
        readedFamilies.push(family);
      } else {
        unreadFamilies.push(family);
      }
    }

    if (this.type == FamilyListAccordioinType.UNREAD_FAMILY) {
      this.families = unreadFamilies;
    } else if (this.type == FamilyListAccordioinType.READED_FAMILY) {
      this.families = readedFamilies;
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### メッセージ送信したメッセージにひもづく家族を取得する
   */
  public async getSendMessageReadFamilies(): Promise<Array<SendMessageReadFamilyModel>> {
    const families: Array<SendMessageReadFamilyModel> = await this.sendMessageReadFamiliesService.get(userStore, Number(this.state.datetime));

    return families;
  }
}

export enum FamilyListAccordioinType {
  UNREAD_FAMILY = 0,
  READED_FAMILY = 1
}
</script>
